export const normalize = {
  journey: (j: any) => ({
    journey_id: j.id,
    journey_uid: j.uid,
    journey_name: j.name
  }),

  stage: (s: any) => ({
    stage_id: s.id,
    stage_uid: s.uid,
    stage_name: s.name,
    stage_journey_id: s.journey_id
  }),

  level: (l: any) => ({
    level_id: l.id,
    level_uid: l.uid,
    level_name: l.name,
    level_total_point_reward: l.total_point_reward ?? l.point_reward ?? 0,
    level_total_coin_reward: l.total_coin_reward ?? l.coin_reward ?? 0,
    level_continue: l._levelContinue,
    level_finished_percentage: l._finishedPercent,
    level_correct_percentage: l._correctPercent,
    stage_id: l.stage_id
  }),

  challenge: (c: any) => ({
    challenge_id: c.id,
    challenge_uid: c.uid,
    challenge_name: c.name,
    challenge_kind: c.kind,
    challenge_position: c.position,
    challenge_active: c.active,
    challenge_locked_until: c.locked_until,
    challenge_unlock_after_previous_challenge:
      c.unlock_after_previous_challenge,
    challenge_locked: c.locked,
    challenge_point_reward: c.point_reward ?? 0,
    challenge_coin_reward: c.coin_reward ?? 0,
    challenge_time_limit: c.time_limit,
    meta_question_kind: c.meta?.question_kind,
    // Evite conteúdo sensível do meta:
    word_pool_size: c.meta?.words?.length,
    correct_words_count: (c.meta?.words || []).filter((w: any) => w.is_correct)
      .length,
    level_id: c.level_id
  }),

  mission: (m: any) => ({
    mission_id: m.id,
    mission_name: m.name,
    required_levels: m.required_levels,
    completed_levels: m.completed_levels
  }),

  document: (d: any) => ({
    document_id: d.id ?? d.uid ?? d.slug,
    document_title: d.title ?? d.name,
    document_type: d.type, // 'material' | 'assignment' | 'certificate' | ...
    file_ext: d.file_ext,
    bytes: d.bytes
  })
}
